import React from "react";

export default function SocialMedia({ title, name, value, register, children }) {

  return (
    <label className={`label-social-media ${value}`}>
      <input hidden type="radio" name={name} value={value} {...register(name)}/>
      <span><div className="mr-10">{children}</div> {title}</span>
    </label>
  );
}